import { Link } from "react-router-dom";
import Filter from "./Filter";

const Sidebar = () => {
    return (
        <div className="sidebar">
            <nav>
                <ul className="space-y-4">
                    <Filter />

                    <li>
                        <Link
                            to="/add"
                            className="main-menu"
                            id="lws-addJob-menu"
                        >
                            <i className="fa-solid fa-file-circle-plus"></i>
                            <span>Add NewJob</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
